import type React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import type { InputProps } from "../../../types/FormTypes";
import styles from "./Switch.module.scss";
import { withRefProp } from "../../../utils/withRefProp";

export interface SwitchProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "checked" | "onChange" | "value"  | "onBlur" | "onFocus">, Omit<InputProps<boolean>, "onChange"> {
  ref?: React.Ref<HTMLButtonElement>;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const DefaultSwitch = withRefProp((props: SwitchProps) => {
  const { className, value, onValueChange, checked, onCheckedChange, ref, ...otherProps } = props;

  const resolvedChecked = checked ?? value;

  const handleCheckedChange = (newChecked: boolean) => {
    onCheckedChange?.(newChecked);
    onValueChange?.(newChecked);
  };

  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={Boolean(resolvedChecked)}
      className={clsx(styles.switch, className)}
      data-state={resolvedChecked ? "checked" : "unchecked"}
      onClick={() => {
        if (otherProps.disabled) return;
        handleCheckedChange(!resolvedChecked);
      }}
      data-deci-switch="true"
      {...otherProps}
    >
      <span className={styles.thumb} />
    </button>
  );
});

const Switch = createPluggable<SwitchProps>("deci.switch", DefaultSwitch);

export default Switch;
